import { render } from "./SceneConstructorBgColorMenu.vue?vue&type=template&id=9340622e&ts=true"
import script from "./SceneConstructorBgColorMenu.vue?vue&type=script&lang=ts"
export * from "./SceneConstructorBgColorMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__